<template>
  <div
    class="kd-button"
    :class="classes"
    :style="style"
    @click="onClick"
  >
    <img v-if="icon" :src="icon" class="kd-button__icon" />
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
    type: String,
    color: String,
    backgroundColor: String,
    size: String,
    noFill: Boolean,
    isDeactivated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      const css = {};
      if (this.color) { css.color = this.color; }
      if (this.backgroundColor) { css.backgroundColor = this.backgroundColor; }
      return css;
    },
    classes() {
      return [
        `kd-button--${this.type}`,
        `kd-button--${this.size}`,
        {
          'kd-button--no-fill': this.noFill,
          'kd-button--deactivated': this.isDeactivated,
        },
      ];
    },
  },
  methods: {
    onClick() {
      if (!this.isDeactivated) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss">
  .kd-button {
    align-items: center;
    display: flex;
    cursor: pointer;
    user-select: none;

    &:hover:not(&--deactivated) {
      opacity: 0.85;
    }

    &--big {
      height: 60px;
      padding: 0 24px;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 600;
      max-width: 280px;

      @media all and (max-width: 1200px) {
        height: 40px;
        padding: 0 12px;
        font-size: 16px;
        max-width: 240px;
      }
    }

    &--medium {
      height: 40px;
      padding: 0 16px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;

      @media all and (max-width: 1200px) {
        height: 30px;
        padding: 0px 8px;
      }
    }

    &--primary {
      background-color: #84C731;
      color: white;
    }

    &--secondary {
      background-color: #01A3DF;
      color: white;
    }

    &--link {
      background-color: transparent;
      color: #999999;
    }

    &--deactivated {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  .kd-button__icon {
    display: inline-block;

    .kd-button--medium &{
      height: 16px;
      margin-right: 14px;
    }

   .kd-button--big &{
      height: 22px;
      margin-right: 14px;
    }
  }
</style>
